import type {AdminRender} from 'quickstart/types'
import {AdminWrapper} from './AdminWrapper'
import {createRoot} from 'react-dom/client'

/**
 * Block admin renderer.
 */
export const renderAdmin: AdminRender = ({
  global = false,
  info: {Admin, GlobalAdmin, globalMigrate, migrate, name},
  render,
  root: container,
  ...props
}) => {
  const wrappedAdmin = (
    <AdminWrapper
      component={global ? GlobalAdmin! : Admin}
      global={global}
      migrate={global ? globalMigrate : migrate}
      name={name}
      {...props}
    />
  )
  // Under test, pass back whatever the render function returns.
  // Note that the test still needs to pass in a textarea.
  if (render) {
    return render(wrappedAdmin)
  }
  // In normal operation, render and return the cleanup function.
  const root = createRoot(container)
  root.render(wrappedAdmin)
  return () => {
    root.unmount()
  }
}
